module.exports = __webpack_public_path__ + "img/HSA Infographic.9fab1a5b.jpeg";